import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, shareReplay, startWith } from 'rxjs';
import { Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { apis } from '../config/api';

@Injectable({
  providedIn: 'root'
})

export class LanguagesService {

  http = inject(HttpClient);

  getLanguages(params: Params): Observable<any> {
    return this.http.get(apis.languages, { params });
  }

  getLanguages$() {
    return this.getLanguages({ limit: -1 }).pipe(
      map(({ languages }) => ({
        languages: languages?.map((row: any) => ({
          value: row.id,
          label: row.name,
          code: row.code,
          id: row.id, // duplicate for multiselect
        })) ?? [],
        loading: false,
        error: null
      })),
      startWith({ languages: [], loading: true, error: null }),
      catchError(() =>
        of({ languages: [], loading: false, error: 'Failed to load languages' })
      ),
      shareReplay(1)
    );
  }

  associateUserLanguages(userId: string, languageIds: string[]): Observable<any> {
    return this.http.post(`${apis.users}/${userId}/languages`, { languageIds });
  }
}
